import axios from "axios";

const hourOffsetString = localStorage.getItem('tm-offset') || '-5';
let hourOffset = -5;

try {
    hourOffset = parseInt(hourOffsetString);
} catch (e) {}

export const TimeManager = {
    ENDPOINT: 'https://timemanagerapi.maxgoddard.dev/v1/',
    getEndpoint: (url) => TimeManager.ENDPOINT + url + '/',
    makeRequest: (method, url, data = {}, config = {}) => new Promise((resolve, reject) => {
        axios({
            method,
            url: TimeManager.getEndpoint(url),
            data,
            headers: {
                ...(config.headers || {}),
                'Authorization': config.token ? `Bearer ${config.token}` : undefined,
            },
        }).then((res) => {
            const data = res.data;

            if (data.error) {
                reject(data);
            } else {
                resolve(data);
            }
        }).catch((err) => {
            reject({
                error: 'NETWORK_ERROR',
                message: 'Encountered a network error.',
                data: err,
            });
        });
    }),
    account: {
        login: (email, password) =>
            TimeManager.makeRequest(
                'post',
                'account/login',
                { email, password },
            ),
        logout: (token) =>
            TimeManager.makeRequest(
                'post',
                'account/logout',
                { token },
            ),
        link: {
            canvas: (canvasToken, token) =>
                TimeManager.makeRequest(
                    'post',
                    'account/link/canvas',
                    { token: canvasToken },
                    { token },
                ),
        },
        sendInvite: (token, email) =>
            TimeManager.makeRequest(
                'post',
                'account/invite',
                { email },
                { token }
            ),
        create: (token, email, username, password) =>
            TimeManager.makeRequest(
                'post',
                'account/create',
                { token, email, username, password },
            ),
    },
    user: {
        self: (token) =>
            TimeManager.makeRequest(
                'post',
                'user/self',
                {},
                { token },
            )
    },
    time: {
        period: {
            getBetween: (start, end, token) =>
                TimeManager.makeRequest(
                    'post',
                    'time/period',
                    { start: TimeManager.dateToSQL(start), end: TimeManager.dateToSQL(end) },
                    { token },
                ).then((data) => {
                    data.periods.forEach((period) => {
                        period.start = TimeManager.dateFromSQL(period.start);
                        period.end = TimeManager.dateFromSQL(period.end);
                    });

                    return data.periods;
                }),
            alter: (data, token) =>
                TimeManager.makeRequest(
                    'post',
                    'time/period',
                    {
                        ...data,
                        start: data.start ? TimeManager.dateToSQL(data.start) : undefined,
                        end: data.end ? TimeManager.dateToSQL(data.end) : undefined
                    },
                    { token },
                )
        },
        task: {
            getBetween: (start, end, token) =>
                TimeManager.makeRequest(
                    'post',
                    'time/task',
                    { start: TimeManager.dateToSQL(start), end: TimeManager.dateToSQL(end) },
                    { token },
                ).then((data) => {
                    data.tasks.forEach((task) => {
                        task.start = TimeManager.dateFromSQL(task.start);
                        task.end = TimeManager.dateFromSQL(task.end);
                    });

                    return data.tasks;
                }),
            alter: (data, token) =>
                TimeManager.makeRequest(
                    'post',
                    'time/task',
                    {
                        ...data,
                        start: data.start ? TimeManager.dateToSQL(data.start) : undefined,
                        end: data.end ? TimeManager.dateToSQL(data.end) : undefined
                    },
                    { token },
                ),
            batch: (tasks, token) =>
                TimeManager.makeRequest(
                    'post',
                    'time/task/batch',
                    tasks.map((data) => ({
                        ...data,
                        start: data.start ? TimeManager.dateToSQL(data.start) : undefined,
                        end: data.end ? TimeManager.dateToSQL(data.end) : undefined
                    })),
                    { token },
                )
        },
        event: {
            getBetween: (start, end, token) =>
                TimeManager.makeRequest(
                    'post',
                    'time/event',
                    { start: TimeManager.dateToSQL(start), end: TimeManager.dateToSQL(end) },
                    { token },
                ).then((data) => {
                    data.events.forEach((event) => {
                        event.start = TimeManager.dateFromSQL(event.start);
                        event.end = TimeManager.dateFromSQL(event.end);
                    });

                    return data.events;
                }),
            alter: (data, token) =>
                TimeManager.makeRequest(
                    'post',
                    'time/event',
                    {
                        ...data,
                        start: data.start ? TimeManager.dateToSQL(data.start) : undefined,
                        end: data.end ? TimeManager.dateToSQL(data.end) : undefined,
                        recurring_end: data.recurring_end ? TimeManager.dateToSQL(data.recurring_end) : undefined
                    },
                    { token },
                )
        },
        label: {
            list: (token) =>
                TimeManager.makeRequest(
                    'post',
                    'time/label',
                    {},
                    { token },
                ).then((data) => data.labels),
            alter: (data, token) =>
                TimeManager.makeRequest(
                    'post',
                    'time/label',
                    data,
                    { token },
                ),
        },
        saved: {
            period: {
                get: (token) =>
                    TimeManager.makeRequest(
                        'post',
                        'time/saved/period',
                        {},
                        { token },
                    ),
                set: (data, token) =>
                    TimeManager.makeRequest(
                        'post',
                        'time/saved/period',
                        { data },
                        { token }
                    ),
            }
        },
    },
    import: {
        canvas: (token) =>
            TimeManager.makeRequest(
                'post',
                'import/canvas',
                {},
                { token },
            )
    },
    dateFromSQL: (dateString) => {
        const parts = dateString.split(/[- :]/);
        parts[1] -= 1; // Offset for zero-indexed months.
        const utcDate = new Date(...parts);

        return new Date(utcDate.getTime() + hourOffset * 60 * 60 * 1000);
    },
    dateToSQL: (date) => {
        const utcDate = new Date(date.getTime() - hourOffset * 60 * 60 * 1000);

        return `${utcDate.getFullYear()}-${utcDate.getMonth() + 1}-${utcDate.getDate()} ${('' + utcDate.getHours()).padStart(2, '0')}:${('' + utcDate.getMinutes()).padStart(2, '0')}:${('' + utcDate.getSeconds()).padStart(2, '0')}`;
    },
};